import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { DEFAULT_LANG, LANGUAGES, LINK_CONTACT_US_DE, LINK_CONTACT_US_EN, LINK_CONTACT_US_ES, LINK_CONTACT_US_FR, LINK_CONTACT_US_IT, LINK_CONTACT_US_NL, LINK_CONTACT_US_PL } from 'src/app/conf/languages';
import { Lang } from 'src/app/model/lang';
import { selectCurrentLang } from 'src/app/store/user/user.selector';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LanguageDialogComponent } from 'src/app/modules/shared/components/language/language.dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { StandardDesignParameters, StandardFooterLayout, StandardPageLayout } from '../../stdlayoutlib/classes.stdlayoutlib';

@Component({
	selector: 'app-common-footer',
	templateUrl: './common.footer.component.html',
	providers: [DialogService],
	styles: `
		.noSelectLabel-commonFooter {
			user-select: none;
			-webkit-user-select: none;
		}
	`
})

export class CommonFooterComponent implements OnInit {
	currentLang$: Observable<Lang> = new Observable();
	currentLang: Lang = DEFAULT_LANG;
	languages = LANGUAGES;

	screenWidth: any;
	FOOTER_EXTENDED_MIN_WIDTH = StandardDesignParameters.FOOTER_EXTENDED_MIN_WIDTH;

	flagImagePath = './assets/images/flags/';
	flagImageFormat = '.svg';

	ref: DynamicDialogRef | undefined;

	constructor(
		public app: AppComponent,
		private store: Store<AppState>,
		public dialogService: DialogService,
		private translate: TranslateService,
		private router: Router,
	) { }

	ngOnInit(): void {
		this.currentLang$ = this.store.select(selectCurrentLang);
		this.currentLang$.subscribe((lang: Lang) => {
			this.currentLang = lang;
		});
		this.onResize();
	}

	getCurrentLanguage(): string {
		return this.currentLang.name;
	}

	openNewTabContactUs() {
		let url = LINK_CONTACT_US_EN;
		switch (this.currentLang.code) {
			case 'it-IT': {
				url = LINK_CONTACT_US_IT;
				break;
			}
			case 'es-ES': {
				url = LINK_CONTACT_US_ES;
				break;
			}
			case 'de-DE': {
				url = LINK_CONTACT_US_DE;
				break;
			}
			case 'pl-PL': {
				url = LINK_CONTACT_US_PL;
				break;
			}
			case 'nl-NL': {
				url = LINK_CONTACT_US_NL;
				break;
			}
			case 'fr-FR': {
				url = LINK_CONTACT_US_FR;
				break;
			}
			default: {
				url = LINK_CONTACT_US_EN;
				break;
			}
		}
		window.open(url, '_blank');
	}

	openNewTab(url: string) {
		window.open(url, '_blank');
	}

	openPublicDownloads() {
		this.router.navigate(['/public'], { queryParams: { language: this.currentLang.code } });
	}

	copyrightInfo(): string {
		return StandardFooterLayout.getCopyrightInfo(this.translate);
	}

	getCurrentLanguageName(): string {
		return this.currentLang.name;
	}

	getCurrentLanguageFlag(): string {
		const currentLangFlagFile = this.flagImagePath + this.currentLang.code + this.flagImageFormat;
		return currentLangFlagFile;
	}

	changeLanguage() {
		this.ref = this.dialogService.open(LanguageDialogComponent, {
			header: this.translate.instant('SEL_LANGUAGE'),
			contentStyle: { overflow: 'auto' },
		});
	}

	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile() {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}
}
